import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { auth as AuthGen } from '@valvur/shared-grpc';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-parent-link-approval',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './parent-link-approval.component.html',
  styleUrl: './parent-link-approval.component.scss',
})
export class ParentLinkApprovalComponent {
  #route = inject(ActivatedRoute);
  #http = inject(HttpClient);

  status = signal<'loading' | 'success' | 'error'>('loading');
  messageKey = signal('app.components.parentLinkApproval.status.loading');

  constructor() {
    this.processToken();
  }

  private async processToken(): Promise<void> {
    const token =
      this.#route.snapshot.paramMap.get('token') ??
      this.#route.snapshot.queryParamMap.get('token') ??
      '';
    if (!token) {
      this.status.set('error');
      this.messageKey.set('app.components.parentLinkApproval.status.missingToken');
      return;
    }

    try {
      await firstValueFrom(
        this.#http.post<AuthGen.ParentLinkAcceptResponse>(
          `${environment.baseUrl}/user/parent-links/accept-by-token`,
          { token },
        ),
      );
      this.status.set('success');
      this.messageKey.set('app.components.parentLinkApproval.status.success');
    } catch {
      this.status.set('error');
      this.messageKey.set('app.components.parentLinkApproval.status.invalid');
    }
  }
}
